"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) {
            delay = Math.random() * delay;
        }
        return delay;
    };
}
exports.buildDelayFunction = buildDelayFunction;
//# sourceMappingURL=delayFunction.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/apollo-link-retry/lib/delayFunction.js
// module id = ./node_modules/apollo-link-retry/lib/delayFunction.js
// module chunks = 40